import { AUDIO_GRAPHS } from '../globals';
export function getAudioGraph(anyContext) {
    const audioGraph = AUDIO_GRAPHS.get(anyContext);
    if (audioGraph === undefined) {
        throw new Error('Missing the audio graph of the given context.');
    }
    return audioGraph;
}
//# sourceMappingURL=/build/es2018/helpers/get-audio-graph.js.map